// extracted by mini-css-extract-plugin
module.exports = {"block":"_3p_mbw"};